import CustomerModalQRCode from "./modals/customer-modal-qrcode";

export default CustomerModalQRCode;